module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "electron"
// module id = 230
// module chunks = 0